export { default } from './TeacherInfo';

